import React from "react";
import {
  SecondaryButton,
  PrimaryButton,
} from "../../../components/UI/DesignStandards";

const FormActions = ({ onCancel, loading = false }) => {
  return (
    <div className="border-t border-brand-charcoal/10 pt-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
        <SecondaryButton
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="!px-3 !py-2 text-sm"
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton type="submit" loading={loading}>
          {loading ? "Saving..." : "Save Changes"}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default FormActions;
